var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167969,
    width: 49.9609,
    height: 49.9609,
    rx: 24.9805,
    fill: "#71879C",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3177 17.2825C26.4333 20.4315 30.3978 22.996 33.3131 24.5113L33.3126 25.9108C30.3965 27.1947 26.5469 29.6452 26.5459 32.6776L24.4465 32.6783C24.331 29.2961 27.8307 26.9623 30.2802 26.1451L17.2177 25.9161L17.2184 23.8168L30.2809 24.0457C27.7152 23.3468 24.1006 20.6655 24.2183 17.2832L26.3177 17.2825Z",
    fill: "#212727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8611,
    height: 12.5395,
    fill: "white",
    transform: "translate(25.0352 16) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRounded);
export default __webpack_public_path__ + "static/media/arrow-right-rounded.db1f6078559f3125ac65df9a505fdf8f.svg";
export { ForwardRef as ReactComponent };